import { useEffect, useRef } from 'react';

const DEFAULT_INTERVAL = 30_000;

export function useTaskPolling(
  onTick: () => void,
  intervalMs = DEFAULT_INTERVAL
): void {
  const handlerRef = useRef(onTick);
  handlerRef.current = onTick;

  useEffect(() => {
    let timer: ReturnType<typeof setInterval> | null = null;
    const start = () => {
      if (timer) return;
      timer = setInterval(() => handlerRef.current(), intervalMs);
    };
    const stop = () => {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') start();
      else stop();
    };
    if (document.visibilityState === 'visible') start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [intervalMs]);
}
